import { useState } from "react";
import PropTypes from "prop-types";
import MDBox from "theme/components/MDBox";
import MDInput from "theme/components/MDInput";
import { Snackbar, Alert } from "@mui/material";

function BVNField({ displayName, fieldRef, isOptional, options }) {
  const [fieldError, showFieldError] = useState(false);

  return (
    <MDBox>
      <MDInput
        name={fieldRef}
        id={`dff_${fieldRef}`}
        margin="dense"
        label={displayName}
        type="text"
        fullWidth
        variant="outlined"
        onBlur={(e) => {
          const bvn = e.target.value;
          const isnum = /^\d+$/.test(bvn);
          if (!isnum || bvn.length !== 11) {
            e.target.value = null;
            showFieldError(true);
          }
        }}
        options={options}
      />
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={5000}
        onClose={() => showFieldError(false)}
        open={fieldError}
      >
        <Alert severity="error" sx={{ width: "100%" }}>
          Invalid BVN provided.
        </Alert>
      </Snackbar>
    </MDBox>
  );
}

// Typechecking props of the Transaction
BVNField.propTypes = {
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.any),
};

BVNField.defaultProps = {
  options: null,
};

export default BVNField;
